import { render, staticRenderFns } from "./AddictiveStuffClientsTable.vue?vue&type=template&id=5a4920df&"
import script from "./AddictiveStuffClientsTable.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports